var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'cc-segment': true,
    'bg-red-8': !_vm.available,
    'bg-grey': _vm.inThePast
  },style:(("\n    width: " + _vm.width + "%;\n    border-left: 1px dashed " + (_vm.$vnode.key % _vm.hide === 0 ? 'grey' : 'transparent') + "\n  "))},[(_vm.$vnode.key % _vm.hide === 0 || _vm.$vnode.key === 0)?_c('div',{staticClass:"cc-block-time"},[_vm._v(" "+_vm._s(_vm.time)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }